import get from 'lodash/get'
import startsWith from 'lodash/startsWith'
import {createSelector} from 'reselect'

import * as URLS from '../urls'

// -- Standard

export const pathname = (state) => get(state, 'router.location.pathname')

// -- Computed

const startsWithY = (y) => (x) => startsWith(x, y)

export const currPageIsInFit = createSelector(pathname, startsWithY(URLS.FIT))

export const currPageIsFitIntro = createSelector(pathname, startsWithY(URLS.FIT_INTRO))

export const currPageIsCheckout = createSelector(pathname, startsWithY(URLS.CHECKOUT))

// -- Args

export const isPage = (state, slug) => pathname(state) === slug
